import { ActivatedRoute } from '@angular/router';
var ViewCardComponent = /** @class */ (function () {
    function ViewCardComponent(activatedRoute) {
        this.activatedRoute = activatedRoute;
    }
    return ViewCardComponent;
}());
export { ViewCardComponent };
